





import RootLayout from '@/components/Root.vue';

export default {
  components: {
    RootLayout,
  },
  computed: {
    cssVariable() {
      return {
        '--color-regional-section': `#${
          this.$store.state.regionProfile?.colorMenuSection || '0074D9'
        }`,
        '--color-regional-search': `#${
          this.$store.state.regionProfile?.colorSearch || '2ECC40'
        } `,
        '--color-regional-menu': `#${
          this.$store.state.regionProfile?.colorMenuMain || '2ECC40'
        } `,
        '--color-regional-btn-success': `#${
          this.$store.state.regionProfile?.colorBtnSuccess || '0074D9'
        } `,
      };
    },
  }
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue